import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export const AddNew = (props) => {
  const { onClickCall } = props;
  return (
    <div>
      <Stack direction="row" spacing={2}>
        <Button size="md" variant="contained" onClick={onClickCall}>
          {props.title ? props.title : "Add New"}
        </Button>
      </Stack>
    </div>
  );
};
